<template>
    <div>
        <h1 class="text-center text-gray-800 dark:text-gray-300 pb-20 mt-12 text-5xl font-extrabold">
            {{$t('Projects')}}
        </h1>
        <div class="flex flex-wrap bg-white dark:bg-gray-700 rounded -mx-px overflow-hidden">
            <div class="w-full hover14 overflow-hidden xl:w-1/2 border-b xl:hidden">
                <div class="p-4">
                    <figure>
                        <img class="w-full " src="../assets/images/projects/mhv.png" alt="MobileHV">
                    </figure>
                </div>
            </div>
            <div class="w-full overflow-hidden xl:w-1/2 border-b border-r">
                <div class="flex flex-col space-y-6 justify-center items-center p-8 mt-8">
                    <div>
                        <h1 class="text-center text-fakhti font-bold text-2xl">MobileHV</h1>
                        <hr class="my-3 border-2">
                    </div>
                    <div>
                        <p style="max-width:500px" class="text-sm lg:text-base leading-loose tracking-relaxed lg:leading-loose lg:tracking-relaxed text-gray-500 dark:text-gray-300 tracking-relaxed text-center whitespace-pre-line">
                            {{$t('MobileHVProject')}}
                        </p>
                    </div>
                </div>
            </div>
            <div class="w-full hover14 overflow-hidden xl:w-1/2 border-b hidden xl:block">
                <div class="p-4">
                    <figure>
                        <img class="w-full h-full" src="../assets/images/projects/mhv.png" alt="MobileHV">
                    </figure>
                </div>
            </div>
            <!-- 1 -->
            <div class="w-full overflow-hidden xl:w-1/2 border-b border-r">
                <div>
                    <figure>
                        <img class="w-full blur-image" src="../assets/images/projects/grid.png" alt="Confidential Project">
                    </figure>
                </div>
            </div>
            <div class="w-full overflow-hidden xl:w-1/2 border-b">
                <div class="flex flex-col justify-center items-center space-y-6 p-8 mt-8 ">
                    <div>
                        <h1 class="text-center text-fakhti font-bold text-2xl">Confidential Search Engine</h1>
                        <hr class="my-3 border-2">
                    </div>
                    <div>
                        <p style="max-width:500px" class="text-sm lg:text-base leading-loose tracking-relaxed lg:leading-loose lg:tracking-relaxed text-gray-500 dark:text-gray-300 tracking-relaxed text-center whitespace-pre-line">
                            {{$t('GridProject')}}
                        </p>
                    </div>
                </div>
            </div>
            <!-- 2 -->
            <div class="w-full hover14 overflow-hidden xl:w-1/2 border-b xl:hidden">
                <div class="p-4">
                    <a target="_blank" href="https://dot-pos-sandbox.vercel.app">
                        <figure>
                            <img class="w-full " src="../assets/images/projects/dot-pos.png" alt="Dot Pos">
                        </figure>
                    </a>
                </div>
            </div>
            <div class="w-full overflow-hidden xl:w-1/2 border-b border-r">
                <div class="flex flex-col space-y-6 justify-center items-center p-8 mt-8">
                    <div>
                        <h1 class="text-center text-fakhti font-bold text-2xl">Dot Pos</h1>
                        <hr class="my-3 border-2">
                    </div>
                    <div>
                        <p style="max-width:500px" class="text-sm lg:text-base leading-loose tracking-relaxed lg:leading-loose lg:tracking-relaxed text-gray-500 dark:text-gray-300 tracking-relaxed text-center whitespace-pre-line">
                            {{$t('DotPosProject')}}
                        </p>
                    </div>
                </div>
            </div>
            <div class="w-full hover14 overflow-hidden xl:w-1/2 border-b hidden xl:block">
                <div class="p-4">
                    <a target="_blank" href="https://dot-pos-sandbox.vercel.app">
                        <figure>
                            <img class="w-full h-full" src="../assets/images/projects/dot-pos.png" alt="dot-pos">
                        </figure>
                    </a>
                </div>
            </div>
            <!-- 3 -->
            <div class="w-full hover14 overflow-hidden cursor-pointer xl:w-1/2 border-b border-r">
                <div>
                    <a target="_blank" href="https://fatoorah.sa/">
                        <figure>
                            <img class="w-full" src="../assets/images/projects/fatoorah.png" alt="Fatoorah Project">
                        </figure>
                    </a>
                </div>
            </div>
            <div class="w-full overflow-hidden xl:w-1/2 border-b">
                <div class="flex flex-col justify-center items-center space-y-6 p-8 mt-8 ">
                    <div>
                        <h1 class="text-center text-fakhti font-bold text-2xl">Fatoorah</h1>
                        <hr class="my-3 border-2">
                    </div>
                    <div>
                        <p style="max-width:500px" class="text-sm lg:text-base leading-loose tracking-relaxed lg:leading-loose lg:tracking-relaxed text-gray-500 dark:text-gray-300 tracking-relaxed text-center whitespace-pre-line">
                            {{$t('FatoorahProject')}}
                        </p>
                    </div>
                </div>
            </div>
            <!-- 4 -->
            <div class="w-full hover14 overflow-hidden xl:w-1/2 border-b xl:hidden">
                <div class="p-4">
                    <a target="_blank" href="https://t-quwaiya.org.sa/">
                        <figure>
                            <img class="w-full " src="../assets/images/projects/itqan.png" alt="Itqan project">
                        </figure>
                    </a>
                </div>
            </div>
            <div class="w-full overflow-hidden xl:w-1/2 border-b border-r">
                <div class="flex flex-col space-y-6 justify-center items-center p-8 mt-8">
                    <div>
                        <h1 class="text-center text-fakhti font-bold text-2xl">Itqan</h1>
                        <hr class="my-3 border-2">
                    </div>
                    <div>
                        <p style="max-width:500px" class="text-sm lg:text-base leading-loose tracking-relaxed lg:leading-loose lg:tracking-relaxed text-gray-500 dark:text-gray-300 tracking-relaxed text-center whitespace-pre-line">
                            {{$t('ItqanProject')}}
                        </p>
                    </div>
                </div>
            </div>
            <div class="w-full hover14 overflow-hidden xl:w-1/2 border-b hidden xl:block">
                <div class="p-4">
                    <a target="_blank" href="https://t-quwaiya.org.sa/">
                        <figure>
                            <img class="w-full h-full" src="../assets/images/projects/itqan.png" alt="Itqan">
                        </figure>
                    </a>
                </div>
            </div>
            <!-- 5 -->
            <div class="w-full hover14 overflow-hidden cursor-pointer xl:w-1/2 border-b border-r">
                <div>
                    <a target="_blank" href="https://maham.app/">
                        <figure>
                            <img class="w-full" src="../assets/images/projects/maham.png" alt="Maham">
                        </figure>
                    </a>
                </div>
            </div>
            <div class="w-full overflow-hidden xl:w-1/2 border-b ">
                <div class="flex flex-col justify-center items-center space-y-6 p-8 mt-8">
                    <div>
                        <h1 class="text-center text-fakhti font-bold text-2xl">Maham</h1>
                        <hr class="my-3 border-2">
                    </div>
                    <div>
                        <p style="max-width:500px" class="text-sm lg:text-base leading-loose tracking-relaxed lg:leading-loose lg:tracking-relaxed text-gray-500 dark:text-gray-300 tracking-relaxed text-center whitespace-pre-line">
                            {{$t('MahamProject')}}
                        </p>
                    </div>
                </div>
            </div>
            <!-- 6 -->
            <div class="w-full hover14 overflow-hidden xl:w-1/2 border-b xl:hidden">
                <div class="p-4">
                    <a target="_blank" href="https://basimadroop.com/">
                        <figure>
                            <img class="w-full " src="../assets/images/projects/basimadroop.png" alt="Basima Droop">
                        </figure>
                    </a>
                </div>
            </div>
            <div class="w-full overflow-hidden xl:w-1/2 border-b border-r">
                <div class="flex flex-col space-y-6 justify-center items-center p-8 mt-8">
                    <div>
                        <h1 class="text-center text-fakhti font-bold text-2xl">Basima Droop</h1>
                        <hr class="my-3 border-2">
                    </div>
                    <div>
                        <p style="max-width:500px" class="text-sm lg:text-base leading-loose tracking-relaxed lg:leading-loose lg:tracking-relaxed text-gray-500 dark:text-gray-300 tracking-relaxed text-center whitespace-pre-line">
                            {{$t('BasimadroopProject')}}
                        </p>
                    </div>
                </div>
            </div>
            <div class="w-full hover14 overflow-hidden xl:w-1/2 border-b hidden xl:block">
                <div class="p-4">
                    <a target="_blank" href="https://basimadroop.com/">
                        <figure>
                            <img class="w-full h-full" src="../assets/images/projects/basimadroop.png" alt="Basima Droop">
                        </figure>
                    </a>
                </div>
            </div>
            <!-- 7 -->
            <div class="w-full hover14 overflow-hidden cursor-pointer xl:w-1/2 border-b border-r">
                <div>
                    <a target="_blank" href="https://www.youtube.com/watch?v=GJ825HreLJw">
                        <figure>
                            <img class="w-full" src="../assets/images/projects/soto.webp" alt="SOTO">
                        </figure>
                    </a>
                </div>
            </div>
            <div class="w-full overflow-hidden xl:w-1/2 border-b ">
                <div class="flex flex-col justify-center items-center space-y-6 p-8 mt-8">
                    <div>
                        <h1 class="text-center text-fakhti font-bold text-2xl">SOTO</h1>
                        <hr class="my-3 border-2">
                    </div>
                    <div>
                        <p style="max-width:500px" class="text-sm lg:text-base leading-loose tracking-relaxed lg:leading-loose lg:tracking-relaxed text-gray-500 dark:text-gray-300 tracking-relaxed text-center whitespace-pre-line">
                            {{$t('SOTOProject')}}
                        </p>
                    </div>
                </div>
            </div>
            <!-- 8 -->
        </div>
    </div>
</template>


<script>
export default {
    name:'Projects',
    methods:{
        goToProjects(){this.$router.push({ name: 'Projects' })}
    }
}
</script>

<style scoped>
/* Shine */
.hover14 figure {
	position: relative;
}
.hover14 figure::before {
	position: absolute;
	top: 0;
	left: -75%;
	z-index: 2;
	display: block;
	content: '';
	width: 50%;
	height: 100%;
	background: -webkit-linear-gradient(left, rgba(255,255,255,0) 0%, rgba(255,255,255,.3) 100%);
	background: linear-gradient(to right, rgba(255,255,255,0) 0%, rgba(255,255,255,.3) 100%);
	-webkit-transform: skewX(-25deg);
	transform: skewX(-25deg);
}
.hover14 figure:hover::before {
	-webkit-animation: shine 1.5s;
	animation: shine 1.5s;
}
@-webkit-keyframes shine {
	100% {
		left: 125%;
	}
}
@keyframes shine {
	100% {
		left: 125%;
	}
}

.blur-image {
	filter: blur(10px);
	-webkit-filter: blur(10px);
}
</style>